import { ProductReasonColletion } from "../collections/product-reason-collection";
import { ProductReason } from "./product-reason";
export class ProductItem {
  constructor(
    serialNo,
    description,
    patient,
    repairWarrantyEndDate,
    modelNo,
    color,
    isInitialProduct,
    remakeWarrantyEndDate,
    lossAndDamageWarrantyEndDate,
  ) {
    this.isInitialProduct = isInitialProduct;
    this.serialNo = serialNo;
    this.description = description;
    this.patientName = patient;
    this.repairWarrantyEndDate = repairWarrantyEndDate;
    this.remakeWarrantyEndDate = remakeWarrantyEndDate;
    this.reasons = new ProductReasonColletion();
    this.modelNo = modelNo;
    this.color = color;
    this.imageUrl = undefined; // If null it's because we don't have an image
    this.remakeWarrantyEndDate = remakeWarrantyEndDate;
    this.lossAndDamageWarrantyEndDate = lossAndDamageWarrantyEndDate;
  }

  addReason(id, text) {
    this.reasons.add(new ProductReason(id, text));
  }

  removeReason(id) {
    this.reasons.remove(id);
  }

  //This will get the correct product image
  //First it will try to find the image in the PIM based on modelNo and color
  //If no match in PIM, then get the warranty based on serial number and return image from Sitecore
  //returns null if no image has been found
  getImageUrlAsync() {
    if (this.imageUrl !== undefined) {
      // we already have image, no need to try again
      return new Promise((resolve, reject) => {
        resolve(this.imageUrl);
      });
    }

    if (this.color && this.modelNo) {
      // try to load image from PIM
      return fetch(
        `${window.location.origin}/api/pim/getColorImageAssets/${this.modelNo}?filetype=psd&color=${this.color}&primary=true`,
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((data) => {
          if (data.length > 0) {
            const primaryImage = data[0]?.ThumbnailUrls["thumbnail220"] || data[0]?.Path;
            this.imageUrl = primaryImage;
            return primaryImage;
          } else {
            // image has still not been set from PIM, so we need to load default image
            return getImageFromSitecore(this);
          }
        })
        .catch((error) => {
          // image has still not been set from PIM, so we need to load default image
          return getImageFromSitecore(this);
        });
    } else {
      return getImageFromSitecore(this);
    }

    function getImageFromSitecore(thisRef) {
      return fetch(
        `/api/warranty/serialnumbers/getwarranty?serialNumber=${thisRef.serialNo}`,
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((data) => {
          thisRef.imageUrl = data.ImageUrl;
          return thisRef.imageUrl;
        })
        .catch((error) => {
          thisRef.imageUrl = null;
          return thisRef.imageUrl;
        });
    }
  }
}
